var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "robot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H13.5V9H15V7.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5H9V9H10.5V7.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15H15.75V13.5H16.5C16.8977 13.4995 17.279 13.3414 17.5602 13.0602C17.8414 12.779 17.9995 12.3977 18 12V9H19.5V7.5H18V6C17.9995 5.60232 17.8414 5.22105 17.5602 4.93984C17.279 4.65864 16.8977 4.50046 16.5 4.5H15V1.5H13.5V4.5H10.5V1.5H9V4.5H7.5C7.10232 4.50046 6.72105 4.65864 6.43984 4.93984C6.15864 5.22105 6.00046 5.60232 6 6V7.5H4.5V9H6V12C6.00046 12.3977 6.15864 12.779 6.43984 13.0602C6.72105 13.3414 7.10232 13.4995 7.5 13.5H8.25V15H4.5C4.10232 15.0005 3.72105 15.1586 3.43984 15.4398C3.15864 15.721 3.00046 16.1023 3 16.5V22.5H4.5V16.5H19.5V22.5H21V16.5C20.9995 16.1023 20.8414 15.721 20.5602 15.4398C20.2789 15.1586 19.8977 15.0005 19.5 15ZM7.5 6H16.5V12H7.5V6ZM9.75 13.5H14.25V15H9.75V13.5Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.337a1bbc2b35b10cba08cf9fd3e9392e.svg";
export { ForwardRef as ReactComponent };